// extracted by mini-css-extract-plugin
export var blue = "_34-g";
export var brand = "_34-c";
export var darkGrey = "_34-f";
export var disabled = "_34-6";
export var disabledSubtle = "_34-7";
export var error = "_34-8";
export var green = "_34-h";
export var grey = "_34-e";
export var icon = "_34-0";
export var inherit = "_34-b";
export var lightGrey = "_34-d";
export var orange = "_34-j";
export var pink = "_34-l";
export var primary = "_34-1";
export var purple = "_34-m";
export var quaternary = "_34-4";
export var quinary = "_34-5";
export var red = "_34-k";
export var secondary = "_34-2";
export var success = "_34-a";
export var tertiary = "_34-3";
export var warning = "_34-9";
export var white = "_34-n";
export var yellow = "_34-i";